module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2",
    attrs: {
      "id": "ch00_fm08_ack"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_xi"
    }
  }), _c('strong', [_vm._v("Acknowledgments")])]), _vm._v(" "), _c('p', {
    staticClass: "paraspaceabove"
  }, [_vm._v("As the poet George Seferis said, “Our words are children of many people.” This book would not have been possible without the help of many people during the course of my studies and work. The idea for this book started from a conversation with my mother, but its foundation was laid much earlier. I owe gratitude to my parents, who encouraged me along the path of knowledge and creation; my teachers all the way from elementary school to medical school and throughout my medical and research training, who introduced me to “brave new worlds”; my colleagues, with whom I continue to share knowledge; and my patients and their families, who continually offer me new challenges.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("To my husband and sons, who were patient and forgiving of my absences for hours—day and night—as I spent my free time writing, I extend my heart-felt thanks. My special thanks to my father, Dr. Petros Kourtis, a general surgeon, to my husband, Dr. Alexander Kessler, an infectious diseases specialist, and my colleague Dr. Andi Shane, a pediatric infectious diseases specialist, who read various parts or all of my manuscript and provided thoughtful and useful comments. Jacqueline Wehmueller, executive editor at the Johns Hopkins University Press, believed in this project from the beginning, and Rowena Rae, my enthusiastic editor, made the book much more interesting to read. Finally, to my publishing team, which made the process, despite the hard work, exciting, I express my deep gratitude."), _c('a', {
    attrs: {
      "id": "page_xii"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cda61a76","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/ch00_fm08_ack.vue
// module id = 81
// module chunks = 0